import { render, staticRenderFns } from "./FullerImage.vue?vue&type=template&id=705ccb7d&"
import script from "./FullerImage.vue?vue&type=script&lang=js&"
export * from "./FullerImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports